(function ($) {
    $(document).on('click', '.product-color-swatch_big', function (e) {
        let product = $(this).data('product-id'),
            product_gallery = $('#js-product-gallery');

        let data = {
            action: 'load_variation_imgs',
            product: product,
        };

        $('.product-gallery').prepend('<div class="product-gallery__loader"><i class="icon-load"></i></div>');

        $.ajax({
            type: 'post',
            url: wc_add_to_cart_params.ajax_url,
            data: data,
            success: function (response) {
                // remove preload
                $('.product-gallery__loader').remove();

                if (response.success) {
                    product_gallery.find('.product-gallery').remove();
                    product_gallery.append(response.html);

                    // rebuild gallery
                    productGalleryDraw();
                }
            },
            error: function(response){
            }
        });
    });


    productGalleryDraw();


    function productGalleryDraw(){
        $('.product-gallery').each(function (i, e){
            let that = $(this);
            let slider = that.find('.product-gallery__slider .splide');

            let main  = new Splide(slider[0], {
                type : 'fade',
                rewind: true,
                arrows: false,
                autoplay: true,
                interval: 3000,
                pagination: false,
                cover: true,
            });

            let thumbnails = new Splide( that.find('.product-gallery__thumbnails .splide')[0], {
                rewind: true,
                direction: 'ttb',
                height: '100%',
                fixedWidth: '100%',
                fixedHeight: '20%',
                /*perPage: 5,*/
                isNavigation: true,
                /*gap: 15,*/
                /*focus: 'center',*/
                pagination: false,
                cover: true,
                /*dragMinThreshold: {
                    mouse: 4,
                    touch: 10,
                },*/
                breakpoints: {
                    1300: {
                        direction: 'ltr',
                        fixedWidth: false,
                        fixedHeight: false,
                        perPage: 4,
                        gap: 15,
                    },
                    992: {
                        type   : 'loop',
                        perPage: 3,
                        padding: '3rem',
                        /*focus: 'center',*/
                    },
                    767: {
                        arrows: false,
                    }
                },
            } );

            main.sync( thumbnails );
            main.mount();
            thumbnails.mount();
        });
    }

})(jQuery);